import { useCallback } from "react";

import type { AirHostReservationSyncJob } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { SiteControllerSettingAirHostReservationSyncJob_SettingPage_Query } from "../schema";

export const useAirHostReservationSyncJobQuery = ({
	hotelID,
	airHostApiAccessToken,
	airHostPartnerID,
	airHostPropertyID,
}: {
	hotelID: string;
	airHostPartnerID: string;
	airHostApiAccessToken: string;
	airHostPropertyID: string;
}) => {
	const isSkip = Boolean(!airHostPartnerID || !airHostApiAccessToken || !airHostPropertyID);

	const { data, refetch } = useCustomSuspenseQuery(
		SiteControllerSettingAirHostReservationSyncJob_SettingPage_Query,
		{
			variables: { hotelID },
		},
		isSkip,
	);

	const onRefetchReservationSyncJob = useCallback(
		async ({ hotelID }: { hotelID: string }) => {
			const res = await refetch({
				hotelID,
			});

			return res.data;
		},
		[refetch],
	);

	const reservationSyncJob: AirHostReservationSyncJob | null =
		data?.siteControllerSettingAirHostReservationSyncJob ?? null;

	return { reservationSyncJob, onRefetchReservationSyncJob };
};
